<template>
  <div>
    <div style="height: 100px"></div>
    <div class="card-container d-flex justify-center">
      <div class="card-one card-width mx-10" @click="goToLogin">
        <div class="img-one"></div>
        <div class="btn-base btn-one">
          <p>이메일 등록한 사람</p>
        </div>
        <div class="content">
          <p>이메일 주소로 쉽게 로그인 할 수 있습니다.</p>
        </div>
      </div>
      <div class="card-three card-width mx-10" @click="goToTrial">
        <div class="img-three"></div>
        <div class="btn-base btn-three">
          <p>처음이신가요?</p>
        </div>
        <div class="content">
          <p>2주간 28가지 귀여운 동물들을 모두 사용할 수 있습니다</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
    goToTrial() {
      this.$router.push("/user/new");
    },
  },
};
</script>

<style scoped>
.card-width {
  width: 350px;
  border-radius: 42px;
  box-shadow: 2px 2px 22px rgba(0, 0, 0, 0.2);
  transition: 0.3s box-shadow, 0.3s margin-top ease-in-out;
}
.card-width:hover {
  box-shadow: 2px 12px 32px rgba(0, 0, 0, 0.5);
  margin-top: 30px;
  cursor: pointer;
}
.img-one {
  width: 350px;
  height: 300px;
  border-radius: 42px;
  background: url("@/assets/temp/left.jpg") no-repeat;
  background-size: 120%;
  background-position-y: 40%;
  background-position-x: 40%;
  /* background-size: cover; */
}
.card-one {
  height: 500px;
  background-color: #ffe697;
}
.btn-base {
  display: flex;
  width: 260px;
  height: 50px;
  border-radius: 50px;
  margin: 0 auto;
  margin-top: -25px;
  font-size: 30px;
  justify-content: center;
  align-items: center;
  color: white;
}
.btn-one {
  background-color: #ff8a8a;
}
.card-three {
  height: 500px;
  background-color: #b7e0ff;
}
.img-three {
  width: 350px;
  height: 300px;
  border-radius: 42px;
  background: url("@/assets/temp/right.jpg") no-repeat;
  background-size: cover;
  /* background-size: 10%; */
  /* background-position-y: 100%; */
  background-position-x: 50%;
}
.btn-three {
  background-color: #31a2fa;
}

.content {
  padding: 15px 35px;
  font-size: 16px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
@media (max-width: 1314px) {
  .card-width {
    margin-top: 25px;
  }
  .card-width:hover {
    box-shadow: 2px 12px 32px rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
}

.v-application p {
  margin: 0;
}
</style>
